export class GesamtverdienstUndLohnbestandteile {
  grundlohnMitarbeitendeDurchschnitt: number;
  grundlohnFrauenDurchschnitt: number;
  grundlohnMaennerDurchschnitt: number;
  grundlohnDifferenz: string;
  zulagenMitarbeitendeDurchschnitt: number;
  zulagenFrauenDurchschnitt: number;
  zulagenMaennerDurchschnitt: number;
  zulagenDifferenz: string;
  monatslohn13MitarbeitendeDurchschnitt: number;
  monatslohn13FrauenDurchschnitt: number;
  monatslohn13MaennerDurchschnitt: number;
  monatslohn13Differenz: string;
  sonderzahlungenMitarbeitendeDurchschnitt: number;
  sonderzahlungenFrauenDurchschnitt: number;
  sonderzahlungenMaennerDurchschnitt: number;
  sonderzahlungenDifferenz: string;
  totalMitarbeitendeDurchschnitt: number;
  totalFrauenDurchschnitt: number;
  totalMaennerDurchschnitt: number;
  totalDifferenz: string;
  grundlohnMitarbeitendeAnteil: string;
  grundlohnFrauenAnteil: string;
  grundlohnMaennerAnteil: string;
  zulagenMitarbeitendeAnteil: string;
  zulagenFrauenAnteil: string;
  zulagenMaennerAnteil: string;
  monatslohn13MitarbeitendeAnteil: string;
  monatslohn13FrauenAnteil: string;
  monatslohn13MaennerAnteil: string;
  sonderzahlungenMitarbeitendeAnteil: string;
  sonderzahlungenFrauenAnteil: string;
  sonderzahlungenMaennerAnteil: string;
  totalMitarbeitendeAnteil: string;
  totalFrauenAnteil: string;
  totalMaennerAnteil: string;
  grundlohnMitarbeitendeErhalten: string;
  grundlohnFrauenErhalten: string;
  grundlohnMaennerErhalten: string;
  zulagenMitarbeitendeErhalten: string;
  zulagenFrauenErhalten: string;
  zulagenMaennerErhalten: string;
  monatslohn13MitarbeitendeErhalten: string;
  monatslohn13FrauenErhalten: string;
  monatslohn13MaennerErhalten: string;
  sonderzahlungenMitarbeitendeErhalten: string;
  sonderzahlungenFrauenErhalten: string;
  sonderzahlungenMaennerErhalten: string;

  grundlohnMitarbeitendeErhaltenAnzahl: number;
  grundlohnFrauenErhaltenAnzahl: number;
  grundlohnMaennerErhaltenAnzahl: number;
  zulagenMitarbeitendeErhaltenAnzahl: number;
  zulagenFrauenErhaltenAnzahl: number;
  zulagenMaennerErhaltenAnzahl: number;
  monatslohn13MitarbeitendeErhaltenAnzahl: number;
  monatslohn13FrauenErhaltenAnzahl: number;
  monatslohn13MaennerErhaltenAnzahl: number;
  sonderzahlungenMitarbeitendeErhaltenAnzahl: number;
  sonderzahlungenFrauenErhaltenAnzahl: number;
  sonderzahlungenMaennerErhaltenAnzahl: number;
}
